let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kvWGt")).then(() => parcelRequire('bwe76'));